import React from 'react';
import { Link } from 'react-router-dom';
import { MapPin, ArrowRight } from 'lucide-react';
import { useApp } from '../context/AppContext';
import { popularRoutes, currencySymbols, rates } from '../mock/mock';
import { slugify } from '../mock/guides';

const PopularRoutes = () => {
  const { t, currency } = useApp();
  const fmt = (n) => `${currencySymbols[currency]} ${Math.round(n * rates[currency])}`;
  return (
    <section className="py-20 bg-[color:var(--brand-muted)]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <div className="max-w-3xl mb-12">
          <h2 className="text-3xl sm:text-4xl font-extrabold text-[color:var(--brand-dark)]">{t('routes.title')}</h2>
          <p className="mt-4 text-gray-500 leading-relaxed">{t('routes.subtitle')}</p>
        </div>
        <div className="grid grid-cols-2 lg:grid-cols-3 gap-3 sm:gap-6">
          {popularRoutes.map((r, i) => (
            <Link to={`/guide/${slugify(r.route)}`} key={i} className="card-hover group bg-white rounded-2xl overflow-hidden flex flex-col sm:flex-row" data-testid={`route-card-${i}`}>
              <img src={r.img} alt={r.route} className="w-full h-28 sm:w-28 sm:h-auto object-cover" />
              <div className="p-4 flex-1 flex flex-col justify-between">
                <div className="flex items-start gap-1.5">
                  <MapPin className="w-4 h-4 mt-0.5 shrink-0" style={{ color: 'var(--brand-accent-hover)' }} />
                  <span className="font-bold text-sm text-[color:var(--brand-dark)] leading-snug">{r.route}</span>
                </div>
                <div className="flex items-center justify-between mt-3">
                  <span className="text-xs text-gray-400">from <b className="text-[color:var(--brand-dark)] text-sm">{fmt(r.price)}</b></span>
                  <ArrowRight className="w-4 h-4 text-[color:var(--brand-dark)] group-hover:translate-x-1 transition-transform" />
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
};

export default PopularRoutes;
